import {Component, Prop, Vue} from "vue-property-decorator";


import Icon from 'kpc/components/icon';

@Component({
    components: {
        Icon
    }
})
export default class KpcViewTitle extends Vue {

    @Prop({
        required: true,
        default: ''
    })
    title!: string

    @Prop({
        required: false,
        default: ''
    })
    titleLink!: string

    @Prop({
        required: false,
        default: () => []
    })
    subs!: any[]
}
